import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/pay-invoices`, {params})
    },
    statistics(params) {
        return Vue.axios.get(`/pay-invoices/statistics`, {params})
    },
    getListOfStatisticsFile() {
        return Vue.axios.get(`/pay-invoices/files`)
    },
    downloadStatisticsFile(file) {
        return Vue.axios.get(`/pay-invoices/files/${file}/download`, {
            responseType: 'blob'
        })
    },
    export() {
        return Vue.axios.get(`/pay-invoices/products/export`)
    },
    runCompareWithIiko() {
        return Vue.axios.get(`/pay-invoices/compare/run`)
    },
}
